import { icon, node } from "~/util/dom";
import ModuleHeightProfile from "./height-profile";
import ModuleItinerary from "./itinerary";
import ModuleWeather from "./weather";
import { ROUTE_CONST } from "~/route/const";
import { ModuleRouteDebug } from "./debug";

export default class SummaryModules {
	_modules: Array<any>;

	_container: HTMLDivElement;

	_data: any;

	_routeState: any;

	_index: number;

	constructor(data, routeState, index) {
		this._data = data;
		this._index = index;
		this._routeState = routeState;
		this._container = node("div", { className: "route-modules" });

		this._modules = [];

		this._build();
	}

	destroy() {
		this._modules.forEach(module => {
			module.destroy();
		});
		this._container.remove();
	}

	get container() {
		return this._container;
	}

	show() {
		this._modules.forEach(module => {
			if (typeof module.show === "function") {
				module.show();
			}
		});
	}

	hide() {
		this._modules.forEach(module => {
			if (typeof module.hide === "function") {
				module.hide();
			}
		});
	}

	reloadState() {
		this._modules.forEach(module => {
			if (typeof module.reloadState === "function") {
				module.reloadState();
			}
		});
	}

	_build() {
		const routeState = Mapy.CML.state.route;
		const isTrip = routeState.items[0]?.tripData?.length;

		if (routeState.params.type !== ROUTE_CONST.TYPE_PUBT || isTrip) {
			this._modules.push(new ModuleWeather(this._data, this._index));
		}
		this._modules.push(new ModuleHeightProfile(this._data, this._routeState));
		Mapy.CUS?.route?.anotherCriterionDebug && this._modules.push(new ModuleRouteDebug(this._data, this._routeState));

		if (!isTrip && (routeState.params.type === ROUTE_CONST.TYPE_CAR || routeState.params.type === ROUTE_CONST.TYPE_BIKE || routeState.params.type === ROUTE_CONST.TYPE_WALK)) {
			this._modules.push(new ModuleItinerary(this._data, this._routeState));
		}
		// pripneme DOM
		this._modules.forEach(module => {
			this._container.appendChild(module.container);
		});
	}
}

export function buildSummaryModule(options: {
	title?: string;
	icon?: string;
	sdsIcon?: HTMLElement;
	active?: boolean;
	className?: string;
	headerClassName?: string;
	switcher?: boolean;
}) {
	const opt = {
		title: options.title || "",
		icon: options.sdsIcon || icon(options.icon || ""),
		active: options.active || false,
		className: options.className || "",
		headerClassName: options.headerClassName || "",
		switcher: options.switcher || false,
	};
	const container = node("div", { className: "module-content" });

	if (opt.className && opt.className !== "") {
		const cls = opt.className.split(" ");

		cls.forEach(cl => {
			container.classList.add(cl);
		});
	}

	const header = node("div");

	header.appendChild(opt.icon);
	header.appendChild(document.createTextNode(opt.title));
	container.appendChild(header);

	if (opt.headerClassName && opt.headerClassName !== "") {
		const cls = opt.headerClassName.split(" ");

		cls.forEach(cl => {
			header.classList.add(cl);
		});
	}

	let switcher = null;
	let indicator = null;
	let switcherContainer = null;

	if (opt.switcher) {
		indicator = node("span", { className: "indicator" });
		switcher = node("input", { type: "checkbox" });
		const label = node("label", { className: "switch" });
		const slider = node("span", { className: "slider" });

		container.classList.add("switcher");

		label.appendChild(indicator);
		label.appendChild(switcher);
		label.appendChild(slider);

		header.appendChild(label);
	} else {
		switcherContainer = node("div", { className: "module-content" });
		container.appendChild(switcherContainer);
	}

	return {
		header,
		switcher,
		switcherContainer,
		container,
		indicator,
	};
}
